module.exports = __webpack_public_path__ + "img/h5.a3d6313f.jpg";